import { PRODUCT_IDS, TOOL_IDS } from '@adsk/alloy-provider';
import { Route, LAYOUTS } from './types';

export default [
  {
    toolId: 'demo-app',
    productId: PRODUCT_IDS.BUILD,
    path: '/build/demo-app/*',
    scope: 'accDemoApp',
    titleKey: 'RFIS_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.CORRESPONDENCE,
    productId: PRODUCT_IDS.BUILD,
    path: '/build/correspondence/*',
    scope: 'accCorrespondence',
    titleKey: 'CORRESPONDENCE_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.CORRESPONDENCE,
    productId: PRODUCT_IDS.DESIGN_COLLABORATION,
    path: '/dc/correspondence/*',
    scope: 'accCorrespondence',
    titleKey: 'CORRESPONDENCE_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.CORRESPONDENCE,
    productId: PRODUCT_IDS.MODEL_COORDINATION,
    path: '/model/correspondence/*',
    scope: 'accCorrespondence',
    titleKey: 'CORRESPONDENCE_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.MEETINGS,
    productId: PRODUCT_IDS.BUILD,
    path: '/build/meetings/*',
    scope: 'accMeetings',
    titleKey: 'MEETINGS_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.MEETINGS,
    productId: PRODUCT_IDS.MODEL_COORDINATION,
    path: '/model/meetings/*',
    scope: 'accMeetings',
    titleKey: 'MEETINGS_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.MEETINGS,
    productId: PRODUCT_IDS.DESIGN_COLLABORATION,
    path: '/dc/meetings/*',
    scope: 'accMeetings',
    titleKey: 'MEETINGS_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.RFIS,
    productId: PRODUCT_IDS.BUILD,
    path: '/build/rfis/*',
    scope: 'accRfis',
    titleKey: 'RFIS_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.PHOTOS,
    productId: PRODUCT_IDS.BUILD,
    path: '/build/photos/*',
    scope: 'acsPhotos',
    titleKey: 'PHOTOS_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.SCHEDULE,
    productId: PRODUCT_IDS.BUILD,
    path: '/build/schedule/*',
    scope: 'accSchedule',
    titleKey: 'SCHEDULE_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.DOCUMENTS,
    productId: PRODUCT_IDS.BUILD,
    path: '/build/files/*',
    scope: 'accDocs',
    titleKey: 'FILES_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.SHEETS,
    productId: PRODUCT_IDS.BUILD,
    path: '/build/sheets/*',
    scope: 'accDocs',
    titleKey: 'SHEETS_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.SPECS,
    productId: PRODUCT_IDS.BUILD,
    path: '/build/specs/*',
    scope: 'accSpecs',
    titleKey: 'SPECS_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.DOCUMENTS,
    productId: PRODUCT_IDS.DOCS,
    path: '/docs/files/*',
    scope: 'accDocs',
    titleKey: 'FILES_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.REVIEWS,
    productId: PRODUCT_IDS.DOCS,
    path: '/docs/reviews/*',
    scope: 'accDocs',
    titleKey: 'REVIEWS_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.TRANSMITTALS,
    productId: PRODUCT_IDS.DOCS,
    path: '/docs/transmittals/*',
    scope: 'accDocs',
    titleKey: 'TRANSMITTALS_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.PACKAGES,
    productId: PRODUCT_IDS.DOCS,
    path: '/docs/packages/*',
    scope: 'accDocs',
    titleKey: 'PACKAGES_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.SETTINGS,
    productId: PRODUCT_IDS.DOCS,
    path: '/docs/settings/*',
    scope: 'accDocs',
    titleKey: 'SETTINGS_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.DOCUMENTS,
    productId: PRODUCT_IDS.COST,
    path: '/cost/files/*',
    scope: 'accDocs',
    titleKey: 'FILES_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.DOCUMENTS,
    productId: PRODUCT_IDS.AUTOSPECS,
    path: '/autospecs/files/*',
    scope: 'accDocs',
    titleKey: 'FILES_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.DOCUMENTS,
    productId: PRODUCT_IDS.TAKEOFF,
    path: '/takeoff/files/*',
    scope: 'accDocs',
    titleKey: 'FILES_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    toolId: TOOL_IDS.SUBMITTALS,
    productId: PRODUCT_IDS.BUILD,
    path: '/build/submittals/*',
    scope: 'accSubmittals',
    titleKey: 'SUBMITTALS_TITLE',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
  },
  {
    path: '/projects',
    scope: 'accProjectList',
    moduleKey: 'projectListModule',
    layout: LAYOUTS.PROJECT_DIRECTORY_LAYOUT,
  },
  {
    path: '/projects/templates',
    scope: 'accProjectList',
    moduleKey: 'projectTemplatesModule',
    layout: LAYOUTS.PROJECT_DIRECTORY_LAYOUT,
  },
  {
    path: '/home',
    scope: 'accUserHome',
    moduleKey: 'toolModule',
    layout: LAYOUTS.PROJECT_DIRECTORY_LAYOUT,
  },
] satisfies Route[];
